import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

const OptionInput = ({ control, name, label, errors, className, options, disabled }) => {
  return (
    <div className={cn(" flex flex-col gap-2 relative min-h-[36px] md:min-h-[46px]  ", className)}>
      <label htmlFor={name} className="text-[14px] md:text-[16px]">
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        defaultValue={true}
        render={({ field: { onChange, value: active } }) => {
          return (
            <div
              className={`flex p-1 bg-neutral-20 gap-2 text-[14px] md:text-[16px]  rounded-v-md min-w-[200px] h-full ${disabled && "pointer-events-none"}`}
            >
              {options.map((item) => (
                <button
                  tabIndex={"-1"}
                  key={item.value.toString()}
                  type="button"
                  disabled={disabled}
                  value={item.value}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onChange(item.value);
                  }}
                  className={`flex-1 ${
                    item.value === active ? "bg-neutral-10 " : ""
                  } rounded-v-md flex justify-center items-center cursor-pointer`}
                >
                  {item.title}
                </button>
              ))}
            </div>
          );
        }}
      />
      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
};

export default OptionInput;
